// themes/Theme.ts
import { createTheme } from '@mui/material/styles';

export const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 700,    // Alterado de 600px para 700px
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  // Outras configurações do tema...
});